<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "paperTypeEdit",
      url: {
        get: "admin/system/paperType",
        edit: "admin/system/paperType",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "纸张名称",
          name: "typeName",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "纸张单价",
          name: "rate",
          value: "",
          type: "input",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
        },
      ],
      forms: {},
    };
  },
  created() {
    // this.loadItemsFieldDrop('serviceCategoryDropTree', 'pid')
  },
  methods: {},
};
</script>
